module.exports = __webpack_public_path__ + "img/btn_close_w.a93a61c2.svg";